/* tslint:disable */

/**
 */
export class RoleForm {
    id?: number;
    name?: string;
    display_name?: string;
}
